module.exports = __webpack_public_path__ + "static/media/settingsNavbar.1babed34.svg";